import { useContext } from 'react';
import { HouseholdChartsDataContext } from '../contexts/HouseholdChartsDataContext';

export const useHouseholdChartsDataContext = () => {
    return useContext(HouseholdChartsDataContext);
};
